import { cn } from '@/lib/utils';
import React, { HTMLAttributes } from 'react';
import styles from './container.module.scss';

export interface ContainerProps {
  children?: React.ReactNode;
}

export const Container = ({
  children,
  className,
  ...props
}: ContainerProps & HTMLAttributes<HTMLDivElement>) => {
  return (
    <div className={cn(styles.component, className)} data-testid="container" {...props}>
      {children}
    </div>
  );
};

export default Container;
